module.exports = __webpack_public_path__ + "static/media/Saira-Bold.e4a6dc53.ttf";